import React from "react"
import "./Contacts.scss"

import cn from "classnames"

import { useTranslation } from "react-i18next"
import { brandConstansByLanguage } from '../../domain_utils'

function Contacts({ contacts, country }) {
  const { t } = useTranslation()
  const brand = brandConstansByLanguage(country)
  const address = brand.address

  return (
    <section className={cn("contacts")}>
      <h1>{t("contacts.contactsWord")}</h1>

      <p>{t("contacts.addressWord")}</p>
      <p>{t("contacts.address", { address })}</p>

      {contacts.map((contact, index) => (
        <React.Fragment key={index}>
          <hr />
          <p>{contact.title}</p>
          <p>{t("contacts.workingHours")}</p>
          {contact.schedule.map((schedule, i) => (
            <p key={i}>{schedule}</p>
          ))}

          <p>
            {t("contacts.phone")} <a href={contact.tel}>{contact.number}</a>
            {contact.secondTel ? <a href={contact.secondTel}>{contact.secondNumber}</a> : ''}
          </p>
        </React.Fragment>
      ))}

      <p>
        {t("contacts.email")} <br />
        <a
          href={t("contacts.links.link-1.href")}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t("contacts.links.link-1.title")}
        </a>
      </p>
    </section>
  )
}

export default Contacts
